/**
 * contains the abi and contract address
*/

class GuildSequencesContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "previousHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "newHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "encryptedTitle",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32[9]",
				"name": "encryptedContentKey",
				"type": "bytes32[9]"
			},
			{
				"internalType": "bytes32[6]",
				"name": "publicKey",
				"type": "bytes32[6]"
			},
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			}
		],
		"name": "editSequence",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "guildsAddress",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "encryptionAddress",
				"type": "address"
			}
		],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "sequenceHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			},
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "previousHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "encryptedTitle",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "bytes32[9]",
				"name": "encryptedContentKey",
				"type": "bytes32[9]"
			},
			{
				"indexed": false,
				"internalType": "bytes32[6]",
				"name": "publicKey",
				"type": "bytes32[6]"
			}
		],
		"name": "NewGuildSequence",
		"type": "event"
	}
        ];

        this.contractAddress = '0x15Da2ef01D9F881f694Be962Db28b76110fa195C';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default GuildSequencesContract;
